import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popover} from "react-bootstrap";

class RepeatSendPopover extends Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        onSave: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        itemRate: this.props.item.proposedRate || 0,
        totalRate: Math.round((this.props.item.proposedRate || 0) * this.props.item.count)
    };

    render() {
        const {item, onSave, close, ...props} = this.props;
        return (
            <Popover id="repeat-send-popover" {...props} style={{width: '300px', minWidth: '300px'}}>
                <div className="m-b-2">
                    <form className="form-horizontal">
                        <div class="form-group">
                            <label class="col-md-4 control-label">Всего</label>
                            <div class="col-md-8">
                                <input type="number" className="form-control"
                                       placeholder="Всего" min="0"
                                       value={this.state.totalRate}
                                       onChange={event => this.updateTotalRate(event.target.value)}/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-4 control-label">За штуку</label>
                            <div class="col-md-8">
                                <input type="number" className="form-control"
                                       placeholder="За штуку" min="0"
                                       value={this.state.itemRate}
                                       onChange={event => this.updateItemRate(event.target.value)}/>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="clearfix">
                    <button type="button" className="btn btn-default btn-3d"
                            onClick={() => close()}>
                        Отмена
                    </button>
                    <button type="button" className="btn btn-success btn-3d pull-right"
                            onClick={() => this.send()}>
                        Отправить
                    </button>
                </div>
            </Popover>
        );
    }

    updateTotalRate(totalRate) {
        this.setState({
            totalRate,
            itemRate: (totalRate / this.props.item.count).toFixed(2)
        });
    }

    updateItemRate(itemRate) {
        this.setState({
            totalRate: Math.round(itemRate * this.props.item.count),
            itemRate
        });
    }

    send() {
        const {onSave, close} = this.props;

        onSave(this.state.itemRate);
        close();
    }
}

export default RepeatSendPopover;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/modals/popovers/RepeatSendPopover.js